import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const SchoolInformation = () => {
    
    return (
        <>
            <Header />
            <Breadcrumb title="School Information" midBreadcrumb="Disclosure" mainBreadcrumb=" School Information" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div class="row">
                        <div class="col-12">
                            <h2 class="mainhead">School Information</h2>
                            <div class="tablescroll table-responsive">
                                <table class="table table-bordered">
                                    <tbody>
                                        <tr >
                                            <td>1. </td>
                                            <td width="48%"><strong>Name of the Principal</strong></td>
                                            <td width="48%">Fr. John Marcus Fernandes</td>
                                        </tr>
                                        <tr>
                                            <td>2.</td>
                                            <td><strong>Principal’s Email ID</strong></td>
                                            <td><a href="mailto:matamariamjansevavidyalay@gmail.com">matamariamjansevavidyalay@gmail.com</a></td>
                                        </tr>
                                        <tr >
                                            <td>3.</td>
                                            <td><strong>Principal’s Retirement Date</strong></td>
                                            <td>Transferable</td>
                                        </tr>
                                        <tr>
                                            <td>4.</td>
                                            <td><strong>Affiliation Validity</strong></td>
                                            <td>Till  2031</td>
                                        </tr>
                                        <tr >
                                            <td>5.</td>
                                            <td><strong>Affiliation Status</strong></td>
                                            <td>Extension Till  2031</td>
                                        </tr>
                                        <tr>
                                            <td>6.</td>
                                            <td><strong>Name of the Trust/ Society/ Company</strong></td>
                                            <td>Delhi Catholic Archdiocese</td>
                                        </tr>
                                        <tr >
                                            <td>7.</td>
                                            <td><strong>Society Registration Number</strong></td>
                                            <td>S 512 of 1951 -52</td>
                                        </tr>
                                        <tr>
                                            <td>8.</td>
                                            <td><strong>Registration Date</strong></td>
                                            <td>15/06/1960</td>
                                        </tr>
                                        <tr >
                                            <td>9.</td>
                                            <td><strong>Registration Validity</strong></td>
                                            <td>Permanent</td>
                                        </tr>
                                        <tr>
                                            <td>10.</td>
                                            <td><strong>NOC Issuing Authority</strong></td>
                                            <td>Assistant secretary for education Sec, Haryana.</td>
                                        </tr>
                                        <tr >
                                            <td>11.</td>
                                            <td><strong>Total Number of Teachers (All Classes)</strong></td>
                                            <td>47</td>
                                        </tr>
                                        <tr>
                                            <td>12.</td>
                                            <td><strong>Number of PGT’s</strong></td>
                                            <td>10</td>
                                        </tr>
                                        <tr>
                                            <td>13.</td>
                                            <td><strong>Number of TGT’s</strong></td>
                                            <td>16</td>
                                        </tr>
                                        <tr >
                                            <td>14.</td>
                                            <td><strong>Number of PRT’s</strong></td>
                                            <td>16</td>
                                        </tr>
                                        <tr>
                                            <td>15.</td>
                                            <td><strong>Number of PET’s</strong></td>
                                            <td>3</td>
                                        </tr>
                                        <tr >
                                            <td>16.</td>
                                            <td><strong>Non-Teaching Staffs</strong></td>
                                            <td>4</td>
                                        </tr>
                                        <tr>
                                            <td>17.</td>
                                            <td><strong>Number of Training attended by faculty since last year</strong></td>
                                            <td>5</td>
                                        </tr>
                                        <tr >
                                            <td>18.</td>
                                            <td><strong>Name of the subjects offered for Class 10th</strong></td>
                                            <td>Hindi, English, Mathematics, Social Science, Science</td>
                                        </tr>
                                        <tr>
                                            <td>19.</td>
                                            <td><strong>Name of the subjects offered for Class 12</strong></td>
                                            <td>Hindi, English, Mathematics , Physics, Biology, Chemistry, Economics, Business Studies, Physical
                                                education, Hind.Vocal.Music, computer &amp; Accountancy</td>
                                        </tr>
                                        <tr >
                                            <td>20.</td>
                                            <td><strong>Number of Building Blocks of School</strong></td>
                                            <td>2</td>
                                        </tr>
                                        <tr>
                                            <td>21.</td>
                                            <td><strong>Number of Restrooms</strong></td>
                                            <td>14</td>
                                        </tr>
                                        <tr >
                                            <td>22.</td>
                                            <td><strong>Number of Toilets</strong></td>
                                            <td>80</td>
                                        </tr>
                                        <tr>
                                            <td>23.</td>
                                            <td><strong>Number of Libraries</strong></td>
                                            <td>1</td>
                                        </tr>
                                        <tr >
                                            <td>24.</td>
                                            <td><strong>Number of Laboratories</strong></td>
                                            <td>5</td>
                                        </tr>
                                        <tr>
                                            <td>25.</td>
                                            <td><strong>Number of Lifts/Elevators</strong></td>
                                            <td>No</td>
                                        </tr>
                                        <tr >
                                            <td>26.</td>
                                            <td><strong>Number of Smart Classes</strong></td>
                                            <td>34</td>
                                        </tr>
                                        <tr>
                                            <td>27.</td>
                                            <td><strong>Number of Computers in Computer lab</strong></td>
                                            <td>56</td>
                                        </tr>
                                        <tr >
                                            <td>28.</td>
                                            <td><strong>Number of Canteens (Staff &amp; Student)</strong></td>
                                            <td>0</td>
                                        </tr>
                                        <tr>
                                            <td>29.</td>
                                            <td><strong>Number of Water Purifier</strong></td>
                                            <td>5</td>
                                        </tr>
                                        <tr >
                                            <td>30.</td>
                                            <td><strong>Number of Auditorium</strong></td>
                                            <td>0</td>
                                        </tr>
                                        <tr>
                                            <td>31.</td>
                                            <td><strong>Total Number of Buses (Owned)</strong></td>
                                            <td>16</td>
                                        </tr>
                                        <tr >
                                            <td>32.</td>
                                            <td><strong>Hostel Facility</strong></td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>33.</td>
                                            <td><strong>Gymnasium Facility</strong></td>
                                            <td>No</td>
                                        </tr>
                                        <tr >
                                            <td>34.</td>
                                            <td><strong>Swimming Pool Facility</strong></td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>34.</td>
                                            <td><strong>Wi-Fi Facility</strong></td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr >
                                            <td>35.</td>
                                            <td><strong>Web Server Facility</strong></td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>36.</td>
                                            <td><strong>Availability of Boundary walls</strong></td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr >
                                            <td>37.</td>
                                            <td><strong>Availability of Store Room</strong></td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>38.</td>
                                            <td><strong>Availability of Clinic</strong></td>
                                            <td>No</td>
                                        </tr>
                                        <tr >
                                            <td>39.</td>
                                            <td><strong>Availability of Fire Extinguishers</strong></td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr>
                                            <td>40.</td>
                                            <td><strong>Availability of Water Sprinklers</strong></td>
                                            <td>Yes</td>
                                        </tr>
                                        <tr >
                                            <td>41.</td>
                                            <td><strong>Name of Nearest Nationalized Bank &amp; Distance from Bank</strong></td>
                                            <td>Punjab national bank (0.5 KM)</td>
                                        </tr>
                                        <tr>
                                            <td>42.</td>
                                            <td><strong>Name of Nearest Bus Station &amp; Distance from Station</strong></td>
                                            <td>Narnaul bus (3.00 KM) Depot</td>
                                        </tr>
                                        <tr >
                                            <td>43.</td>
                                            <td><strong>Name of Nearest Railway Station &amp; Distance from Station</strong></td>
                                            <td>Narnaul Railway station ( 5 KM)</td>
                                        </tr>
                                        <tr>
                                            <td>44.</td>
                                            <td><strong>Name of Nearest Airport &amp; Distance from Airport</strong></td>
                                            <td>Indira Gandhi International Airport (145km)</td>
                                        </tr>
                                        <tr >
                                            <td>45.</td>
                                            <td><strong>Name of Nearest Hospital &amp; Distance from Hospital</strong></td>
                                            <td>Civil Hospital (5km)</td>
                                        </tr>
                                        <tr>
                                            <td>46.</td>
                                            <td><strong>Name of Nearest Police Station &amp; Distance from Police Station</strong></td>
                                            <td>Mahavir chowk (4km)</td>
                                        </tr>
                                        <tr >
                                            <td>47.</td>
                                            <td><strong>Name of Nearest Metro Station &amp; Distance from Metro Station</strong></td>
                                            <td>No</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </>
    )
}
export default SchoolInformation